import { MutationResponse } from '@/api/types/common.types';

export enum PaymentMethod {
  Card = 'CARD',
  Wallet = 'WALLET',
  My_card = 'MY_CARD',
  Portmanat = 'PORTMANAT',
  Terminal = 'TERMINAL',
}

export enum PaymentProvider {
  Azericard = 'AZERICARD',
  Goldenpay = 'GOLDENPAY',
  Kapitalbank = 'KAPITALBANK',
  Yigim = 'YIGIM',
}

export enum TerminalPaymentTargetType {
  Ad = 'ad',
  Invoice = 'invoice',
  Balance = 'balance',
}

export enum PaymentService {
  Add_balance_custom = 'add_balance_custom',
}

export enum PaymentStatus {
  Success = 'success',
  Failure = 'failure',
  ContinueToWebsite = 'continue_to_website',
}

type PaymentResult = {
  status: PaymentStatus;
  redirectUrl?: string;
  paymentLegacyId?: string;
  paymentDate?: string;
  targetLegacyId?: string;
  provider: PaymentProvider;
};

export type CreatePaymentResponse = {
  createPayment: MutationResponse<PaymentResult>;
};

export type CreateTerminalPaymentResponse = {
  createTerminalPayment: MutationResponse<boolean>;
};
